import { render } from "./listProposalsForCreate.vue?vue&type=template&id=54a584c4"
import script from "./listProposalsForCreate.vue?vue&type=script&lang=js"
export * from "./listProposalsForCreate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__